import React from "react";
import { BrowserRouter, Route, Routes, Link } from "react-router-dom";
import styled from "styled-components";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import BlogPage from "./pages/BlogPage";

const NotFoundContainer = styled.main`
  text-align: center;
  padding: 5rem 1rem;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const NotFoundTitle = styled.h1`
  font-family: 'Libre Baskerville', serif;
  font-size: 3rem;
  color: var(--primary-color);
  margin-bottom: 1rem;
`;

const NotFoundText = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 1.1rem;
  color: var(--text-dark);
  margin-bottom: 2rem;
`;

const NotFoundLink = styled(Link)`
  display: inline-block;
  padding: 0.8rem 1.8rem;
  background-color: var(--accent-color);
  color: var(--text-light);
  border-radius: 5px;
  text-decoration: none;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: var(--primary-color);
  }
`;

const NotFound = () => (
  <NotFoundContainer>
    <NotFoundTitle>404</NotFoundTitle>
    <NotFoundText>The page you're looking for doesn't exist.</NotFoundText>
    <NotFoundLink to="/">Back to Home</NotFoundLink>
  </NotFoundContainer>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
